export const BASE_CLASS =
  'w-full px-3 py-2.5 text-sm bg-background rounded-lg outline-none border border-outline-variant ring-inset focus-visible:ring-offset-primary disabled:cursor-not-allowed disabled:opacity-50 peer focus:border-primary focus:ring-1 focus:ring-primary focus:ring-inset'

export const BASE_INVALID_CLASS =
  'text-error ring-offset-error focus:border-error ring-offset-1 border-error'
